<template>
  <router-link :to="{name: 'scoutingAdd'}">
    <v-btn color="primary">
      <v-icon left>mdi-account-plus</v-icon>
      Add member
    </v-btn>
  </router-link>
</template>

<script>
    export default {
        name: "BtnAddScouting"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Buttons/Profiles/BtnAddScouting.vue